import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SportsEventTypeSpecialsWidget" */ './SportsEventTypeSpecialsWidget'
    ),
  modules: ['./SportsEventTypeSpecialsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
